import React from "react";
import { useQuery, useQueryClient } from "react-query";
import api from "../../utils/api";
import { useDashboardDataStore } from "../../storesZustand/useDashboardDataStore";

export function useDashboardData(roleId, organizationId, paramOrg) {
  const token = localStorage.getItem("token");
  const queryClient = useQueryClient();

  const [setAllDashboardData, setLocationWithAnalyticsOneOrganization] =
    useDashboardDataStore((state) => [
      state.setAllDashboardData,
      state.setLocationWithAnalyticsOneOrganization,
    ]);

  // Invalidate cache when paramOrg changes (navigation between pages)
  React.useEffect(() => {
    if (paramOrg !== undefined) {
      // When navigating to a specific organization, invalidate the main dashboard cache
      queryClient.invalidateQueries([
        "dashboardData",
        organizationId,
        undefined,
        "main",
      ]);
    } else {
      // When navigating back to main page, invalidate all dashboard caches
      queryClient.invalidateQueries("dashboardData");
    }
  }, [paramOrg, organizationId, queryClient]);

  return useQuery(
    [
      "dashboardData",
      organizationId,
      paramOrg,
      paramOrg === undefined ? "main" : "specific",
    ],
    async () => {
      let org = organizationId;
      if (roleId) {
        if (organizationId === 1 && roleId === 3 && paramOrg === undefined) {
          org = undefined;
        }

        const url = org
          ? `device/dashboard/organization/${paramOrg || organizationId}`
          : "device/dashboard/organization";

        if (token) {
          const response = await api.get(url);
          const data = response?.data?.data;
          if (org) {
            setLocationWithAnalyticsOneOrganization(data);
          } else {
            setAllDashboardData(data);
          }
          return data;
        }
      }
    },
    {
      cacheTime: 60000, // 1 minute cache
      staleTime: 30000, // Consider stale after 30 seconds
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: 3,
      onError: (error) => {
        console.error("Error fetching dashboard data:", error);
        // Clear stale data on error
        setLocationWithAnalyticsOneOrganization(null);
        setAllDashboardData(null);
      },
    }
  );
}

export function useEmployeesForLocations(locations) {
  return useQuery(
    "employeesForLocations",
    async () => {
      const response = api.post(`/location/employeesForLocations/`, {
        locations: locations,
      });

      return response?.data?.data; // Return the data from the API response
    },
    {
      cacheTime: 120000, // Cache data for 60 seconds
      staleTime: 100000, // Consider data stale after 30 seconds
    }
  );
}
